import { InjectionToken } from '@angular/core';
import { Config } from './config.model';

/**
 * Injection token for application configuration.
 * This allows direct injection of the Config object into components and services.
 */
export const APP_CONFIG_TOKEN = new InjectionToken<Config>('Application configuration');
